export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8058.c50bb4b0.jpg";